import { takeLatest, call, put } from 'redux-saga/effects';

import { getDropdowns } from './api';
import { fetchDropdownsSuccess, fetchDropdownsFail } from './actions';
import commonActionTypes from './action-types';

function* fetchDropdownsSaga({ payload }) {
  try {
    const response = yield call(getDropdowns, payload);
    yield put(fetchDropdownsSuccess(response.data.Cities));
  } catch (error) {
    yield put(fetchDropdownsFail(error));
  }
}

function* commonSaga() {
  yield takeLatest(commonActionTypes.FETCH_DROPDOWNS, fetchDropdownsSaga);
}

export default commonSaga;
